import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteService } from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { AlertService } from '../../services/alert.service';
import { RoutesService } from '../../services/routes.service';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../services/dashboard.service';
import swal from 'sweetalert2';
import { SignalRService } from '../../services/signal-r.service';
import { $ } from 'protractor';
import * as $$ from 'jquery';
declare const google: any;
var map: any;
import { NgxSpinnerService } from 'ngx-spinner';
import { MatProgressSpinnerModule } from '@angular/material';
import { RouteDisplayComponent } from '../route-display/route-display.component';


var originMarker: any;
var destinationMarker: any;
var directionsService: any;
var directionsDisplay: any;

var originLat: number;
var originLng: number;
var destinationLat: number;
var destinationLng: number;
var arrCtrlPts: any = [];


var all_overlays: any = [];
var cur = 0;

var isOriginDestinationCreated: boolean = false;
var isOriginCreated: boolean = false;
var isDestinationCreated: boolean = false;
var isRouteCreated: boolean = false;
var isOptionalRouteCreated: boolean = false;
var requestArray = [], renderArray = [], originMarkers = [], destinationMarkers = [];

@Component({
  
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  routes: any = [];
  routetrace: any = {};
  wAux: any[] = [];

  arrVehicles: any = [];
  arrPointsPark: any = [];
  arrPointsDesp: any = [];
  arrAlerts: any = [];
  arrAlertsVehi: any = [];
  arrAlertsVehiTansit: any = [];
  arrAlertsVehiNoClosing: any = [];

  arrPointsWor: any = [];

  countWork: any = 0;
  countPark: any = 0;
  countDesp: any = 0;
  countAlerts: any = 0;
  countVehiclesTansit: any = 0;
  countVehiclesNoClosing: any = 0;
  namePark: any;
  nameDesp: any;
  nameAlertVehi: any;
  idAlertVehi: any;
  nameWorshop: any;
  vehiclesPark: any = [];
  vehiclesAlerts: any = [];
  vehiclesWorkshop: any = [];
  vehiclesDesp: any = [];
  vehiclesTransitCompany: any = [];
  vehiclesTransitComp: any = [];

  vehicleMarkers: any[] = [];

  totalPassengers : any = ""
  totalTrips : any = ""
  waitingForInformation : boolean = true
  waitingForCaidasInformation : boolean = true
  showingCroquis   = false;
  
  tipList : any  = [];
  totalCaidasList : any  = [];
  totalAfter : any  = 0
  totalBefore : any  = 0
  tripList : any  = []

  rol:any = this.commonService.getUserRole()

  @ViewChild('modalListParking') modalListParking: HTMLElement;
  @ViewChild('modalListWorkshop') modalListWorkshop: HTMLElement;
  @ViewChild('modalListDesp') modalListDesp: HTMLElement;
  @ViewChild('modalListAlerts') modalListAlerts: HTMLElement;
  @ViewChild('modalListVehiclesTransit') modalListVehiclesTransit: HTMLElement;
  @ViewChild('modalListTripeList') modalListTripeList: HTMLElement;
  @ViewChild('modalListVehiclesNoClosing') modalListVehiclesNoClosing: HTMLElement;
  @ViewChild('modalCaidasList') modalCaidasList: HTMLElement;
  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;    


  routedisplayRef : any;
  routedisplayfactory : any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private alertService: AlertService,
    private routesService: RoutesService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    localStorage.setItem("vehiclesInTransit", "")
    
    this.getAlertVehicles()
    this.getParkingWorShop();
    this.getOutOfTransitVehicles()
    this.getCaidasInformation()
    this.getTripsInformation()
    this.getTotalVehicles()
    this.getRoutes();
    this.getLocation();
    this.initMap()

    //this.getVehiclesTransit()
    var signarl = new SignalRService(this);
    this.addRouteDisplay()
    this.togglemap()
  }

  getOutOfTransitVehicles(){
    var that = this
    this.dashboardService.getOutOfTransitVehicles()
        .then(response => {
          for(var i in response){
            response[i].startRouteTime = new Date(response[i].startRouteTime)
            response[i].startRouteTime = response[i].startRouteTime.toLocaleString('es-CO', { hour12: true })
          }


          that.countVehiclesNoClosing = response.length;
          that.arrAlertsVehiNoClosing = response
        });
  }

  async getTotalVehicles(){
    var that = this;
    setInterval(async function () {
      that.waitForTotalVehicles();
    }, 10000);
  }
  
  waitForTotalVehicles(){
    this.countVehiclesTansit = localStorage.getItem("totalVehicles")

    // Espera por los vehiculos
    var vehiclesString = localStorage.getItem("vehiclesInTransit")
    if(vehiclesString != undefined && vehiclesString != ""){
      var vehicles = JSON.parse(vehiclesString)
      this.countVehiclesTansit = vehicles.length
      this.arrAlertsVehiTansit = vehicles
      // console.log(this.arrAlertsVehiTansit)

      
    }
  }

  addRouteDisplay() {
    // Inyecta el componente en el div con id container
    const factory = this.componentFactoryResolver.resolveComponentFactory(RouteDisplayComponent);
    this.routedisplayRef = this.viewContainerRef.createComponent(factory);
    this.routedisplayRef.changeDetectorRef.detectChanges();
  }

  getTripsInformation(){
    var that = this
    this.dashboardService.getTripsInformation(this.commonService.getUserName())
        .then(response => {
          this.totalPassengers = response.totalPassengers
          that.tipList = response.Trips

          this.totalTrips = that.tipList.length

          for(var i in this.tipList){

            this.tipList[i].StartDate = new Date(this.tipList[i].StartDate)
            this.tipList[i].StartDate = this.tipList[i].StartDate.toLocaleString('es-CO', { hour12: true })

            console.log("**************************************s")
            console.log(this.tipList[i].EndingDate)
            if(this.tipList[i].EndingDate == "0001-01-01T00:00:00"){
              this.tipList[i].EndingDate = ",En ruta"
            }else{
              this.tipList[i].EndingDate = new Date(this.tipList[i].EndingDate)
              this.tipList[i].EndingDate = this.tipList[i].EndingDate.toLocaleString('es-CO', { hour12: true })
            }
          }

          that.waitingForInformation = false
        });
  }
  getCaidasInformation(){
    var that = this
    this.dashboardService.getCaidasInformation(this.commonService.getUserName())
        .then(response => {
          console.log(response)
          this.totalCaidasList = response.Totals
          var totalAfter = 0
          var totalBefore = 0
          for(var i in this.totalCaidasList){
            this.totalAfter += this.totalCaidasList[i].TotalAfter
            this.totalBefore += this.totalCaidasList[i].TotalBefore
          }
          this.waitingForCaidasInformation = false
          this.tripList = response.Trips
          //this.getAlertVehicles()

        });
  }

  togglemap(){
    this.showingCroquis = !this.showingCroquis;
    $$(".btn-maps").removeClass("btn-default")
    $$(".btn-maps").addClass("btn-primary")
    
    if(this.showingCroquis){
      $$("#map-panel").attr("hidden", "true")// esconde el mapa
      
      $$("#croquis-panel").removeAttr("hidden")// muestra el croquis
      
      $$("#map-button").removeClass("btn-primary")
      $$("#map-button").addClass("btn-default")
  }else{
      $$("#croquis-panel").attr("hidden", "true")// esconde el croquis
      
      $$("#map-panel").removeAttr("hidden")// muestra el mapa
      $$("#croquis-button").removeClass("btn-primary")
      $$("#croquis-button").addClass("btn-default")
    }
  }

  showAlertInfo(plate, notification) {
    var marker = this.vehicleMarkers.filter(function (item) {
      return item.plate === plate;
    })[0];

    if (marker != undefined) {

      var infowindow = new google.maps.InfoWindow();

      infowindow.close(); // Close previously opened infowindow
      var content = '<div>' +
                    "<p>Notificación: " + notification.description + "</p>" +
                    "<p>Placa: " + plate + "</p>" +
                    "</div>"
      
      
      infowindow.setContent(content);
      infowindow.open(map, marker.mark);
      // marker.infowindow.open(map, marker.mark)
    }
  }

  recieveNotification(data) {
    switch (data.type) {
      case "vehicleNotification":
        this.showAlertInfo(data.plate, data.notification)
        break;
    }
  }

  initMap() {
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('initMap')), {
      zoom: 7,
      center: new google.maps.LatLng(4.624335, -74.063644)
    });

  }



  getRoutes(): void {
    var that = this;
    this.routesService.getRoutesByUsername(this.commonService.getUserName()).then(response => {
      if (response) {
        // console.log(response)
        this.routes = response;
        // console.log('response : ', response)
        var waypts = [];
        this.wAux = [];
        var req;
        directionsService = new google.maps.DirectionsService();

        for (var i = 0; i < this.routes.length; i++) {
          // console.log(this.routes[i])
          var col = '#' + ((1 << 24) * Math.random() | 0).toString(16);
          // console.log('route_data : ', this.routes[i].route_data)
          var color = col;
          directionsDisplay = new google.maps.DirectionsRenderer({
            polylineOptions: {
              strokeColor: color
            }
          });

          directionsDisplay.setOptions({ suppressMarkers: true });
          directionsDisplay.setMap(map);

          if(this.routes[i].route_data){
            
            const dataRoute = JSON.parse(this.routes[i].route_data.toString());
            const originLat = dataRoute.origin.originLat;
            const originLng = dataRoute.origin.originLng;
            const destinationLat = dataRoute.destination.destinationLat;
            const destinationLng = dataRoute.destination.destinationLng;
  
            if (dataRoute.waypoints.length > 0) {
              for (let n = 0; n < dataRoute.waypoints.length; n++) {
                // this.wAux[n] = [dataRoute.waypoints[n][0], dataRoute.waypoints[n][1]];
                waypts.push({
                  location: new google.maps.LatLng(dataRoute.waypoints[n][0], dataRoute.waypoints[n][1]),
                  stopover: true
                });
              }
  
              //directionsService = new google.maps.DirectionsService();
  
              req = {
                origin: new google.maps.LatLng(originLat, originLng),
                destination: new google.maps.LatLng(destinationLat, destinationLng),
                waypoints: waypts,
                //optimizeWaypoints: true,
                travelMode: google.maps.DirectionsTravelMode.DRIVING
              };
              waypts = [];
            } else {
              //directionsService = new google.maps.DirectionsService();
              req = {
                origin: new google.maps.LatLng(originLat, originLng),
                destination: new google.maps.LatLng(destinationLat, destinationLng),
                travelMode: google.maps.DirectionsTravelMode.DRIVING
              };
            }

            var currroute = this.routes[i]
            directionsService.route(req, function (result, status) {
              if (status === google.maps.DirectionsStatus.OK) {
                var col = '#' + ((1 << 24) * Math.random() | 0).toString(16);
                // console.log('color : ', col);
                // console.log(cur);
  
                // directionsDisplay.setDirections(response);
                /*if(originMarker != null){
                  originMarker.setMap(null);
                  originMarker = null;
                }
                if(destinationMarker != null){
                  destinationMarker.setMap(null);
                  destinationMarker = null;
                }*/
  
                var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
  
                var coordinateDestination = new google.maps.LatLng(destinationLat, destinationLng);
                //////////originMarker = new google.maps.Marker({
                //////////  position: coordinateOrigin,
                //////////  map: map
                //////////});
  
  
                //////////var pinImage = new google.maps.MarkerImage('http://www.googlemapsmarkers.com/v1/7d2181/');
  
                //////////destinationMarker = new google.maps.Marker({
                //////////  position: coordinateDestination,
                //////////  icon: pinImage,
                //////////  map: map
                //////////});
  
  
                var pinImage = new google.maps.MarkerImage('http://www.googlemapsmarkers.com/v1/27893e/');
                originMarker = new google.maps.Marker({
                  position: coordinateOrigin,
                  icon: pinImage,
                  title: 'Origen Ruta',
                });
  
                originMarkers[cur] = originMarker;
                originMarkers[cur].setMap(map);
                pinImage = new google.maps.MarkerImage('http://www.googlemapsmarkers.com/v1/7d2181/');
                destinationMarker = new google.maps.Marker({
                  position: coordinateDestination,
                  icon: pinImage,
                  map: map,
                  title: 'Destino Ruta',
                });
                destinationMarkers[cur] = destinationMarker;
                destinationMarkers[cur].setMap(map);
                var color = col;
                directionsDisplay = new google.maps.DirectionsRenderer({
                  polylineOptions: {
                    strokeColor: color
                  }
                });
                renderArray[cur] = directionsDisplay;
                renderArray[cur].setOptions({ suppressMarkers: true });
                renderArray[cur].setMap(map);
                renderArray[cur].setDirections(result);
                cur++;
                
                

  
              }
              else{
                console.log(status, result)
              }
            });
            map.setZoom(10);
            map.setCenter(new google.maps.LatLng(originLat, originLng));
          }
          // }

        }
      }
    });
  }

  setMarkerOnMap(vehicle: any) {
    var uid = vehicle.id;
    var latitude = vehicle.Latitude;
    latitude = parseFloat(latitude.replace(',', '.'));
    var plate = vehicle.TrackerName;
    var speed = vehicle.Speed;
    var date = vehicle.DateLoc;
    var longitude = vehicle.Longitude;
    longitude = parseFloat(longitude.replace(',', '.'));

    var html = '<div class="info_content" style="border-radius:10px;">' +
      // '<div style="text-align:center;font-weight:bold;">Placa : </div>' +
      '<p>Placa: ' + plate + '</p>' +
      '<p>Velocidad: ' + speed + ' Kms/h</p>' +
      '<p>Fecha: ' + date + '</p>' +
      '<a class="ti-search btn btn-info" plate="'+ plate +'" id="buttonOnclick">Ver Historial</i></a>' +
      // '<p> Latitud: Descripcion de la ubicación</p>' +
      '</div>';

      var label = plate // '<div style="color: red"><p>' + plate + ' </p></div>'

    var coordinateOrigin = new google.maps.LatLng(latitude, longitude);
    var coordinateDestination = new google.maps.LatLng(latitude, longitude);
    var image = { url: './assets/img/ng serve.png' };

    destinationMarker = new google.maps.Marker({
      position: coordinateDestination,
      icon: { url: './assets/img/busIcon.png', text: '57' }, map: map,
      label: { text: label, color: '#eb3a44', fontSize: '16px', fontWeight: 'bold' },
    });

    destinationMarker['infowindow'] = new google.maps.InfoWindow({
      content: html
    });
    google.maps.event.addListener(destinationMarker, 'click', function () {
      this['infowindow'].open(map, this);
    });
    map.setZoom(10);
    map.setCenter(new google.maps.LatLng(latitude, longitude));

    this.vehicleMarkers.push({ "plate": plate, "mark": destinationMarker});

    google.maps.event.addListenerOnce(destinationMarker['infowindow'], 'domready', () => {
      document.getElementById('buttonOnclick').addEventListener('click', (event) => {
        var target = event.target as HTMLTextAreaElement
        var plate = target.getAttribute("plate")
        this.router.navigate(['/home/alertreport'], { queryParams: { plate: plate } });
      });
    });
  }

  getLocation(): void {

    this.dashboardService.locationVehicle(this.commonService.getUserName(), this.commonService.getUserPass()).then(obj => {
      // console.log(obj)
      for (var i = 0; i < obj.length; i++) {
        this.setMarkerOnMap(obj[i])
      }

    });
  }

  getVehiclesTransit(): void {
    this.dashboardService.getVehiclesTransit(this.commonService.getUserName()).then(obj => {
      
      var objJson = JSON.stringify(obj);
      // console.log('getVehiclesTransit : getVehiclesTransit getVehiclesTransit getVehiclesTransit: ', objJson)
      this.vehiclesTransitComp = objJson;
      //this.countVehiclesTansit = obj['VehiclesT'].length;
      this.countVehiclesNoClosing = obj['VehiclesW'].length;

      // console.log('objJson : getVehiclesTransit', obj )
      for (var i = 0; i < obj['VehiclesT'].length; i++) {
        var jSonV = JSON.parse(obj['VehiclesT'][i])
        var plate = jSonV.Plate
        this.arrAlertsVehiTansit.push(jSonV)
      }

      for (var i = 0; i < obj['VehiclesW'].length; i++) {
        var jSonV = JSON.parse(obj['VehiclesW'][i])
        var plate = jSonV.Plate
        this.arrAlertsVehiNoClosing.push(jSonV)
      }

    });
  }


  getAlertVehicles(): void {
    this.dashboardService.getAlertVehicles_rol(this.commonService.getUserName()).then(obj => {
      var objJson = obj
      console.log(objJson)

      this.arrAlerts = []
      this.arrAlertsVehi = []
      for(var i in objJson){
        console.log(objJson)
        if(objJson[i].list != undefined){
          this.arrAlerts.push({
                                TypeAlert : objJson[i].type,
                                Quantity: objJson[i].list.length, 
                                NameAlert: objJson[i].type,
                                Vehicles : objJson[i].list
                              })
          
          for(var j in objJson[i].list){
            this.arrAlertsVehi.push({
                                      //'quantity' : objJson[i].list[j].length, 
                                      'typeAlert' : objJson[i].typeId, 
                                      'nameAlert' : objJson[i].type, 
                                      'vehicles' : objJson[i].list,
                                    })
          }
        }
      }
      this.countAlerts = objJson.length


      return false

    });
  }

  getParkingWorShop(): void {
    this.dashboardService.getParkingWorShop(this.commonService.getUserName()).then(obj => {
      // console.log(obj)
      for (var i = 0; i < obj.length; i++) {       
        
        var jSonV = JSON.parse(obj[i])
        var quantity = jSonV.Quantity;
        var namePoint = jSonV.NamePoint;
        var vehicles = jSonV.Vehicles;
        var typePoint = jSonV.TypeAlarm;

        if(typePoint == 4){
          this.countPark = this.countPark + quantity; 
          this.arrPointsPark.push({ 'namePoint': namePoint, 'quantity' : quantity, 'typePoint' : typePoint, 'vehicles': vehicles})          
        }
        else if (typePoint == 3){
          this.arrPointsWor.push({ 'namePoint': namePoint, 'quantity' : quantity, 'typePoint' : typePoint, 'vehicles': vehicles})    
          this.countWork = this.countWork + quantity;  
        }
        else if (typePoint == 2){
          this.arrPointsDesp.push({ 'namePoint': namePoint, 'quantity' : quantity, 'typePoint' : typePoint, 'vehicles': vehicles})    
          this.countDesp = this.countDesp + quantity;  
        }


        // console.log('this.arrPointsPark : ', this.arrPointsPark)
      }
      //console.log(this.arrPointsPark)
      // console.log('this.countWork : ', this.countWork)
    });
  }

  openModalAlerts(vehicles, name, idAlert): void {
    this.vehiclesAlerts = [];
    // console.log(vehicles)
    this.nameAlertVehi = name;
    for (var i = 0; i < vehicles.length; i++) {
      this.idAlertVehi = vehicles[i].AlarmTypeId;
      

      this.vehiclesAlerts.push(vehicles[i])

    }
    let that = this;
    const modalAlerts = this.modalService.open(this.modalListAlerts);
  }

  openModalParking(vehicles, name): void {
    this.vehiclesPark = [];
    this.namePark = name;

    for (var i = 0; i < vehicles.length; i++) {
    var jSonList = JSON.parse(vehicles[i])
      this.vehiclesPark.push(jSonList)
    }
    let that = this;
    const modalPark = this.modalService.open(this.modalListParking);
  }

  openModalWorkshop(vehicles, name): void {
    this.vehiclesWorkshop = [];
    this.nameWorshop = name;
    
    for (var i = 0; i < vehicles.length; i++) {
    var jSonList = JSON.parse(vehicles[i])
      this.vehiclesWorkshop.push(jSonList)
    }
    
    let that = this;
    const modalPark = this.modalService.open(this.modalListWorkshop);
  }

  openModalDesp(vehicles, name): void {
    this.vehiclesDesp = [];
    this.nameDesp = name;
    for (var i = 0; i < vehicles.length; i++) {
      var jSonList = JSON.parse(vehicles[i])
      this.vehiclesDesp.push(jSonList)
    }
    let that = this;
    const modalPark = this.modalService.open(this.modalListDesp);
  }

  openModalVehicleTransit(): void {
    this.vehiclesWorkshop = [];

    // for (var i = 0; i < vehicles.length; i++) {
    //   var jSonList = JSON.parse(vehicles[i])
    //   console.log('jSonList  : ', jSonList)
    //   this.vehiclesTransitCompany.push(jSonList)
    // }
    let that = this;
    const modalVehi = this.modalService.open(this.modalListVehiclesTransit);
  }

  openModalTotalCaidas(): void {

    // for (var i = 0; i < vehicles.length; i++) {
    //   var jSonList = JSON.parse(vehicles[i])
    //   console.log('jSonList  : ', jSonList)
    //   this.vehiclesTransitCompany.push(jSonList)
    // }
    let that = this;
    const modalVehi = this.modalService.open(this.modalCaidasList);
  }

  openModalTrips(): void {
    this.vehiclesWorkshop = [];

    // for (var i = 0; i < vehicles.length; i++) {
    //   var jSonList = JSON.parse(vehicles[i])
    //   console.log('jSonList  : ', jSonList)
    //   this.vehiclesTransitCompany.push(jSonList)
    // }
    let that = this;
    const modalVehi = this.modalService.open(this.modalListTripeList);
  }

  openModalVehiclesNoClosing(): void {
    this.vehiclesWorkshop = [];

    // for (var i = 0; i < vehicles.length; i++) {
    //   var jSonList = JSON.parse(vehicles[i])
    //   console.log('jSonList  : ', jSonList)
    //   this.vehiclesTransitCompany.push(jSonList)
    // }
    let that = this;
    const modalVehi = this.modalService.open(this.modalListVehiclesNoClosing, {size: 'lg'});
  }

}





// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/dashboard/dashboard.component.ts